
const easeInOutQuad1 = (t, b, c, d) => {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
}
const easeInOutQuint = (t, b, c, d) => {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
}
const easeInOutExpo = (t, b, c, d) => {
    if (t == 0) return b;
    if (t == d) return b + c;
    if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
}

class I96InternalScroll {

    /**
     * 
     * @param options easing, duration, callback, offset
     */
    constructor( options ) {

        // this.debug = typeof m3_getQueryVariable == 'function' ? m3_getQueryVariable('debug-smooth-scroll') : false;
        this.debug = false;

        this.iz_animating = false;

        this.settings_default = {
            offset: 0,
            callback: null,
            easing: easeInOutQuint,
            duration: 800
        }

        this.settings = {
            ...this.settings_default,
            ...options
        }
        
        this.scroll_data = {
            time_start : false,
            next : 0,
            time_elapsed : 0,
            start : 0
        }

        if (this.debug) console.log('I96InternalScroll > constructor()');

        this.hashlink = false;

        this.init();

    }

    init() {
        this.hashlink = false;

        if (this.debug) console.log('I96InternalScroll > init()', window.location.hash);

        this._getLocationHash();

        if (this.hashlink !== false) {

        }

        // hook into the load event
        window.addEventListener("load", (ev) => {
            this._onLoad(ev);
        });


        window.addEventListener("wheel", (ev) => {
            this._onWheel(ev);
        });

    }

    _onWheel( ev ) {
        this.iz_animating = false;
    }

    _onLoad( ev ) {
        if (this.debug) console.log('I96InternalScroll > _onLoad()', ev);

        document.querySelectorAll('.lewo-internal-link').forEach( ele => {
            ele.addEventListener('click', (e) => {
                const slug = ele.getAttribute('data-target_slug');
                const target = document.querySelector('.lewo-section[data-slug="'+slug+'"]');
                this.scrollTo( target );
            })
        });

    }

    _getLocationHash() {
        if (this.debug) console.log('I96InternalScroll > _getLocationHash()');

        if (window.location.hash) {
            this.hashlink = window.location.hash.substring(1).toLowerCase(); //Puts hash in variable, and removes the # character
            if (this.debug) console.log('I96InternalScroll > hazHash', this.hashlink);
            if (this.hashlink !== '') {
                this.scrollTo( this.hashlink );
            }
        }
    }

    /**
     * Sets the location hash in the url to the data-slug of the given element
     * without triggering the jump (on modern browsers)
     *
     * @param target slug (string) or element
     * @private
     */
    _setLocationHash( target ) {
        if (this.debug) console.log('I96InternalScroll > _setLocationHash()', target);

        let slug = target; // assuming the target is a slug

        if (typeof target !== 'string') {
            slug = target.getAttribute('data-slug');
        }

        if (slug !== '') {
            slug = '#' + slug;
        }

        if(history.pushState) {
            history.pushState(null, null, slug);
        }
        else {
            location.hash = slug;
        }
    }

    /**
     * Gets the first element that has the data-slug attribute === slug
     * @param slug
     * @returns {Element|*}
     * @private
     */
    _getElementBySlug( slug ) {
        if (this.debug) console.log('I96InternalScroll > _getElementBySlug()', slug, document.querySelector('[data-slug="'+slug+'"]'));
        if (typeof slug === 'string') {
            return document.querySelector('[data-slug="' + slug + '"]');
        }
        return slug;
    }

    /**
     * Scrolls to the slug / element
     *
     * @param slug the slug (string) or the target element
     */
    scrollTo( slug ) {
        if (this.debug) console.log('I96InternalScroll > scrollTo()', slug);

        if (this.iz_animating) {
            console.log('I96InternalScroll > scrollTo() : already scrolling');
            return;
        }

        this._setLocationHash( slug )

        const target = this._getElementBySlug( slug );

        this.scroll_data.start = window.scrollY

        this.distance = typeof target === 'object' && target !== null
            ? this.settings.offset + target.getBoundingClientRect().top
            : target

        this.scroll_data.duration = typeof this.settings.duration === 'function'
            ? this.settings.duration( this.distance )
            : this.settings.duration

        if (this.debug) console.log('I96InternalScroll > ', 'distance : ' + this.distance, 'duration : ' + this.scroll_data.duration);
        if (this.debug) console.log('------------------------------------------------');

        this.iz_animating = true;

        requestAnimationFrame(time => this._scroll_loop(time))
    }

    /**
     * This method that will be called in each animation fram to determine the current scroll position
     *
     * @param time
     * @private
     */
    _scroll_loop(time) {

        if(!this.scroll_data.time_start) {
            this.scroll_data.time_start = time
        }

        this.scroll_data.time_elapsed = time - this.scroll_data.time_start
        this.scroll_data.next = this.settings.easing(
            this.scroll_data.time_elapsed,
            this.scroll_data.start,
            this.distance,
            this.scroll_data.duration
        )

        if (this.debug) console.log('I96InternalScroll > _scroll_loop('+time+')', 'elapsed: ' + this.scroll_data.time_elapsed, 'start: ' + this.scroll_data.start, 'next : ' + this.scroll_data.next);

        window.scrollTo(0, this.scroll_data.next);

        // stop animation if wheel was detected / or sth else set iz_animation to false
        if (!this.iz_animating) {
            this._scroll_end( false )
            return;
        }

        this.scroll_data.time_elapsed < this.scroll_data.duration
            ? requestAnimationFrame(time => this._scroll_loop(time))
            : this._scroll_end()
    }

    /**
     * Stops the animation loop
     *
     * @private
     */
    _scroll_end( just_in_case = true ) {
        this.iz_animating = false;

        if (just_in_case) {
            window.scrollTo(0, this.scroll_data.start + this.distance)
        }

        typeof this.settings.callback === 'function' && this.settings.callback()
        this.scroll_data.time_start = false
    }


}

export default I96InternalScroll;
